import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const WHATSAPP = 'https://wa.me/32488152028?text=' + encodeURIComponent('Hallo Max Q, ik heb een vraag over een renovatie.');

const WhatsAppButton = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const [prompt, setPrompt] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => { setPrompt(false); setDismissed(false); const t = setTimeout(() => setPrompt(true), 2000); return () => clearTimeout(t); }, [location.pathname]);

  useEffect(() => {
    // Show after 800ms to avoid flash
    const t = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(t);
  }, []);

  // Hide only inside the private admin area
  if (location.pathname.startsWith('/admin')) {
    return null;
  }
  if (!visible) return null;

  return (
    <>
      {prompt && !dismissed && (
        <div className="wa-renovation-prompt fixed right-4 bottom-24 md:right-24 md:bottom-6 z-40 max-w-[calc(100vw-2rem)] w-72 rounded-2xl bg-white border border-[#25D366]/40 shadow-xl p-4 pr-9">
          <button type="button" onClick={() => setDismissed(true)} aria-label="WhatsApp-tip sluiten" className="absolute right-1 top-1 w-8 h-8 text-xl text-[#202020]/60 rounded-full hover:bg-gray-100">×</button>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-link-location="whatsapp_cta" className="block text-[#202020] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#25D366]">
            <strong className="block text-base mb-1">Renovatieplannen?</strong>
            <span className="block text-sm mb-3">Bespreek uw ideeën met ons.</span>
            <span className="inline-flex items-center rounded-full bg-[#25D366] text-[#102819] px-4 py-2 text-sm font-bold">Chat over uw renovatie →</span>
          </a>
        </div>
      )}
    <a
      href={WHATSAPP}
      target="_blank"
      rel="noopener noreferrer"
      // hidden on mobile because MobileStickyBar already has WhatsApp
      className="wa-attention hidden md:flex fixed bottom-6 right-6 z-40 bg-[#25D366] hover:brightness-95 text-white rounded-full shadow-lg items-center justify-center h-14 w-14 transition-all hover:scale-105"
      aria-label="Chat op WhatsApp met Max Q"
      data-testid="whatsapp-fab"
      data-link-location="whatsapp_fab"
    >
      <svg viewBox="0 0 24 24" className="h-7 w-7 fill-current" aria-hidden="true">
        <path d="M20.52 3.48A11.87 11.87 0 0 0 12.05 0C5.5 0 .17 5.33.17 11.88c0 2.1.55 4.15 1.6 5.96L0 24l6.32-1.66a11.88 11.88 0 0 0 5.73 1.46h.01c6.55 0 11.88-5.33 11.88-11.88 0-3.17-1.24-6.15-3.48-8.4zm-8.47 18.28h-.01a9.86 9.86 0 0 1-5.03-1.38l-.36-.21-3.75.98 1-3.65-.24-.37a9.85 9.85 0 0 1-1.51-5.25c0-5.45 4.44-9.88 9.9-9.88 2.65 0 5.13 1.03 7 2.9a9.83 9.83 0 0 1 2.9 7c0 5.44-4.44 9.87-9.9 9.87zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.03 1-1.03 2.45s1.06 2.84 1.21 3.04c.15.2 2.1 3.2 5.09 4.49.71.3 1.26.49 1.7.62.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z"/>
      </svg>
    </a>
    </>
  );
};

export default WhatsAppButton;
